<div class="when-wrapper" #when>
  <div class="theme-input-mobile">
    <input readonly #whenInput class="input when" [value]="!value ? null : value | mobileDate" type="text" placeholder="Any week" (click)="setFocus($event, true)" >
    <span class="input-icon">
      <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/calendar_2.svg"></svg-icon>
    </span>
  </div>
  <ng-container *ngIf="activeInput === 'when' && (focused | async)">
    <div class="calendar-content">
      <div class="calendar">
        <div class="check-in-out" #checkInOut>
          <div class="check-in-out-inner">
            <div class="check-in-out-btn" (click)="toggleCheckInOut('in')">
              <div>Check in</div>
            </div>
            <div class="check-in-out-btn" (click)="toggleCheckInOut('out')">
              <div>Check out</div>
            </div>
            <div class="check-in-out-slider" [@toggleInOut]="checkInOutState">
              <div>Check {{ checkInOutState }}</div>
            </div>
          </div>
          <div class="days">
            <div>
              <span>S</span>
            </div>
            <div>
              <span>M</span>
            </div>
            <div>
              <span>T</span>
            </div>
            <div>
              <span>W</span>
            </div>
            <div>
              <span>T</span>
            </div>
            <div>
              <span>F</span>
            </div>
            <div>
              <span>S</span>
            </div>
          </div>
        </div>

        <!-- <div class="top"> -->
          <div class="calendar-from">
            <div class="month">
              <div class="title">
                {{ fromMonth | month }} {{ fromYear }}
              </div>
              <div class="dates">
                <ng-container *ngFor="let i of days;">
                  <ng-container *ngIf="(i > fromStartDay!) && ((i - fromStartDay!) <= fromDays!); else empty">
                    <app-day
                      [attr.data-i]="i"
                      [noAvailability]="noAvailability"
                      [attr.data-date]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                      (dayMouseenter)="highlight(i)"
                      (dayMouseleave)="unhighlight()"
                      (dayClick)="clicked(i, i - fromStartDay)"
                      [i]="i"
                      [dateValue]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                      [anchorStart]="anchorStart"
                      [(anchorStartDate)]="anchorStartDate"
                      [anchorEnd]="anchorEnd"
                      [(anchorEndDate)]="anchorEndDate"
                      [(selecting)]="selecting"
                      [firstDayOfMonth]="fromStartDay"
                      [daysInMonth]="fromDays"
                      [toStartDay]="toStartDay"
                      [fromStartDay]="fromStartDay"
                      [monthOffset]="monthOffset"
                      [absoluteAnchorStart]="absoluteAnchorStart"
                      [absoluteAnchorEnd]="absoluteAnchorEnd"
                      [focus]="focus"
                      [month]="'from'"
                      [fromMonth]="fromMonth"
                      [toMonth]="toMonth"
                      [unavailableDates]="unavailableDates"
                      >
                      <span>{{ i - fromStartDay! }}</span>
                    </app-day>
                  </ng-container>
                  <ng-template #empty>
                    <div class="date date-empty">
                      <span></span>
                    </div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="calendar-to">
            <div class="month">
              <div class="title">
                {{ toMonth | month }} {{ toYear }}
              </div>
              <div class="dates">
                <ng-container *ngFor="let i of days;">
                  <ng-container *ngIf="i - 1 >= toStartDay! && (i - toStartDay) <= toDays!; else empty">
                    <app-day
                        [attr.data-i]="i + 40"
                        [noAvailability]="noAvailability"
                        [attr.data-date]="i | dayToDate : toMonth : toStartDay : toYear"
                        (dayMouseenter)="highlight(i + 40)"
                        (dayMouseleave)="unhighlight()"
                        (dayClick)="clicked(i + 40, i - toStartDay)"
                        [i]="i + 40"
                        [dateValue]="i | dayToDate : toMonth : toStartDay : toYear"
                        [anchorStart]="anchorStart"
                        [(anchorStartDate)]="anchorStartDate"
                        [anchorEnd]="anchorEnd"
                        [(anchorEndDate)]="anchorEndDate"
                        [(selecting)]="selecting"
                        [firstDayOfMonth]="toStartDay"
                        [daysInMonth]="toDays"
                        [toStartDay]="toStartDay"
                        [fromStartDay]="fromStartDay"
                        [monthOffset]="monthOffset"
                        [absoluteAnchorStart]="absoluteAnchorStart"
                        [absoluteAnchorEnd]="absoluteAnchorEnd"
                        [focus]="focus"
                        [month]="'to'"
                        [fromMonth]="fromMonth"
                        [toMonth]="toMonth"
                        [unavailableDates]="unavailableDates"
                      >
                      <span>{{ i - toStartDay }}</span>
                    </app-day>
                  </ng-container>
                  <ng-template #empty>
                    <div class="date date-empty">
                      <span></span>
                    </div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        <!-- </div> -->
        <!-- <div class="bottom">
          <div class="buttons">
            <button class="btn btn-frame" (click)="reset()">
              Clear
            </button>
            <button class="btn btn-theme" (click)="doUpdate()" [disabled]="!startDayOfMonth || !endDayOfMonth">
              Apply
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="activeInput === 'when' && (bottomSheetOpen | async)" >
  <div class="fixed-test">
    <button class="btn btn-large" (click)="skip()">
      <ng-container i18n>Skip</ng-container>
    </button>
    <button class="btn btn-theme btn-large" [disabled]="anchorStart == null || anchorEnd == null" (click)="doUpdate()">
      <ng-container i18n>Select these dates</ng-container>
    </button>
  </div>
</ng-container>
